import PricingRulesStore from './PricingRulesStore'

export default PricingRulesStore
